import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ConfigManagerService } from '../../shared/services/config-manager.service';

@Component({
    selector: 'q-layout-secure',
    templateUrl: './layout-secure.component.html',
    styleUrls: ['./layout-secure.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class LayoutSecureComponent implements OnInit {
    version: string;
    businessAppUrl: string;
    constructor(configManagerService: ConfigManagerService) {
        this.version = configManagerService.version;
        this.businessAppUrl = configManagerService.apps.business;
    }

    ngOnInit() {}
}
